<template>
  <div>
    <v-dialog
      scrollable
      v-model="confirmDeactivateDialog"
      persistent
      max-width="400"
    >
      <material-card
        v-if="selectedItem"
        :title="$t('views.organizations.deactivate_{0}', [selectedItem.Name])"
        :color="$vuetify.theme.themes.light.error"
        icon="toggle_off"
      >
        <v-card-text>{{ $t("globals.are_you_sure") }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="saving"
            color
            text
            @click="confirmDeactivateDialog = false"
            >{{ $t("globals.cancel") }}</v-btn
          >
          <v-btn :loading="saving" color="primary" text @click="deactivate">{{
            $t("globals.deactivate")
          }}</v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      scrollable
      v-model="confirmActivateDialog"
      persistent
      max-width="400"
    >
      <material-card
        v-if="selectedItem"
        :title="$t('views.organizations.activate_{0}', [selectedItem.Name])"
        :color="$vuetify.theme.themes.light.success"
        icon="toggle_on"
      >
        <v-card-text>{{ $t("globals.are_you_sure") }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="saving"
            color
            text
            @click="confirmActivateDialog = false"
            >{{ $t("globals.cancel") }}</v-btn
          >
          <v-btn :loading="saving" color="primary" text @click="activate">{{
            $t("globals.activate")
          }}</v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog scrollable v-model="dialogs.edit" persistent max-width="1000px">
      <material-card :title="$t('views.organizations.new_organization')" icon="add" :color="$vuetify.theme.themes.light.success">
        <v-card-text>
          <v-form
            ref="form"
            v-model="valid"
            v-if="organization !== null && organization !== undefined"
          >
            <v-container fluid>
              <v-row>
                <v-col xs="12" sm="6" md="4" lg="3">
                  <no-autocomplete-textfield
                    v-model="organization.Name"
                    :label="$t('globals.name')"
                    :rules="[$rules.required]"
                    class="required"
                  ></no-autocomplete-textfield>
                </v-col>
                <v-col xs="12" sm="6" md="4" lg="3">
                  <image-uploader-string
                    @image-data="
                      organization.BrokerLogo = $event;
                      $forceUpdate();
                    "
                    :image="organization.BrokerLogo"
                    :rules="[$rules.required]"
                    :label="$t('globals.logo')"
                    class="required"
                  ></image-uploader-string>
                </v-col>
                <v-col xs="12" sm="6" md="4" lg="3">
                  <auto-select
                    :value.sync="isActive"
                    :items="status"
                    :label="$t('globals.status')"
                    :rules="[$rules.required]"
                    item-text="text"
                    item-value="value"
                    class="required"
                  >
                  </auto-select>
                </v-col>
                </v-row>
                <v-row>
                <v-col>
                  <span class="text-h6 ml-1">
                    {{ $t("globals.address") }}
                  </span>
                  <canada-post-address
                    :address="organizationAddress"
                    @update-address="
                      organizationAddress = $event;
                      $forceUpdate();
                    "
                    @valid="validAddress = $event"
                  />
                </v-col>
                <!-- <address-form
                  ref="address"
                  :provinces="provinces"
                  :item="organizationAddress"
                ></address-form> -->
                
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="saving" text @click="close">{{
            $t("globals.cancel")
          }}</v-btn>
          <v-btn
            :disabled="!organizationValid()"
            :loading="saving"
            color="primary"
            @click="save"
            >{{ $t("globals.save") }}</v-btn
          >
        </v-card-actions>
      </material-card>
    </v-dialog>
    <material-card
      :title="$t('globals.organizations')"
      :color="$vuetify.theme.themes.light.secondary"
      icon="supervised_user_circle"
    >
      <pbas-data-table
        ref="table"
        :exporters="$exporters"
        :dataProvider="provider"
        :showSelect="false"
        :rowActions="rowActions"
        :floatActions="floatActions"
        @itemsChanged="setData($event)"
        identifier="organizationsTable"
        @error="error=$event"
      ></pbas-data-table>
      <!--<data-table
        ref="table"
        :headers="headers"
        :title="tableTitle"
        tableKey="Id"
        :rowActions="rowActions"
        :selectAll="true"
        @odataItems="setData($event)"
        :displayFunctions="displayFunctions"
        @customHeaders="saveHeaders($event)"
        :columnsOptions="columnsOptions"
        :provider="provider"
      ></data-table>-->
      <v-snackbar
        v-model="snackbar"
        :color="color"
        :multi-line="mode === 'multi-line'"
        :timeout="timeout"
        :vertical="mode === 'vertical'"
      >
        {{ $t(message) }}
        <v-btn dark text @click="snackbar = false">{{
          $t("globals.close")
        }}</v-btn>
      </v-snackbar>
    </material-card>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ODataProvider } from "pbas-vue-components";
import OrganizationsHeaders from "../headers/Organizations";
import ErrorHandler from "../components/ErrorHandler";
import AddressForm from "../components/AddressForm";
import ImageUploaderString from "../components/ImageUploaderString";
import AutoSelect from "../components/AutoSelect";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
import { tokens } from "vue-the-mask";
import masker from "vue-the-mask/src/masker";
import CanadaPostAddress from "../components/CanadaPostAddress.vue";

export default {
  components: {
    ErrorHandler,
    AddressForm,
    ImageUploaderString,
    AutoSelect,
    NoAutocompleteTextfield,
    CanadaPostAddress
  },
  data() {
    return {
      postalCodeMask: "A#A #A#",
      status:[{
        text:this.$t("globals.active"),
        value:true
      }, {
        text:this.$t("globals.inactive"),
        value:false
      }],
      organizationAddress: null,
      error: null,
      provider: undefined,
      saving: false,
      columnsOptions: [],
      selectedItem: null,
      floatActions: [
        {
          name: "addOrganization",
          icon: "add",
          color: this.$vuetify.theme.themes.light.success,
          text: "globals.add_new",
          handler: this.add,
        },
      ],
      rowActions: [
        {
          name: "deactivate",
          icon: "toggle_off",
          title: "globals.deactivate",
          handler: (item) => {
            this.selectedItem = item;
            this.confirmDeactivateDialog = true;
          },
          visible: (item) =>
            item.IsActive === true && item.IsPrincipal === false,
        },
        {
          name: "activate",
          icon: "toggle_on",
          title: "globals.activate",
          handler: (item) => {
            this.selectedItem = item;
            this.confirmActivateDialog = true;
          },
          visible: (item) =>
            item.IsActive === false && item.IsPrincipal === false,
        },
      ],
      tableTitle: "Organizations",
      odata: {
        url: "brokers",
      },
      usersUrl: "users",
      newId: 4,
      confirmDeactivateDialog: false,
      confirmActivateDialog: false,
      indeterminate: false,
      selected: [],
      headerscopy: [],
      customizeColumnsDialog: false,
      snackbar: false,
      color: "",
      mode: "",
      timeout: 2500,
      message: "",
      filters: [],
      valid: false,
      users: [],
      dialogs: {
        edit: false,
      },
      organizations: [],
      headers: OrganizationsHeaders,
      editedIndex: -1,
      organization: null,
      defaultItem: {
        IsActive: true
      },
      isActive: true,
      validAddress: false,
    };
  },
  computed: {
    ...mapGetters("odata", { storeSearch: "search" }),
    // ...mapGetters("plansMembers", { columnsDropDownOptions: "options" }),
  },
  watch: {
    /*editDialog(val) {
      val || this.close();
    }*/
  },
  async mounted() {
    this.provider = new ODataProvider(
      this.$axiosHttp,
      this.odata.url,
      this.headers
    );
    // this.provinces = this.columnsDropDownOptions.Models.Province;
  },
  methods: {
    ...mapActions("applicationUsers", ["updateOrganization"]),
    ...mapActions("plansMembers", ["addOrganization"]),
    unmask(v, mask) {
      if (v) {
        return masker(v, mask, false, tokens);
      }
      return v;
    },
    organizationValid() {
      return this.valid && this.validAddress;//this.addressValid();
    },
    addressValid() {
      return (
        this.$refs.address &&
        // (
        this.$refs.address.valid
        // ||
        //   !this.$refs.address.dirty)
      );
    },
    setData(items) {
      this.organizations = items;
    },
    async deactivate() {
      this.saving = true;
      try {
        let item = JSON.parse(JSON.stringify(this.selectedItem));
        item.IsActive = false;
        delete item.Users;
        delete item.Plans;
        await this.updateOrganization(item);
        this.$refs.table.getDataAsync();
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.confirmDeactivateDialog = false;
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    async activate() {
      this.saving = true;
      try {
        let item = JSON.parse(JSON.stringify(this.selectedItem));
        item.IsActive = true;
        delete item.Users;
        delete item.Plans;
        await this.updateOrganization(item);
        this.$refs.table.getDataAsync();
        this.confirmActivateDialog = false;
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    add() {
      this.organization = JSON.parse(JSON.stringify(this.defaultItem));
      this.dialogs.edit = true;
    },
    close() {
      this.dialogs.edit = false;
      this.organization = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    },
    async save() {
      console.log(this.organizationAddress);
      this.saving = true;

      this.organization.City = this.organizationAddress.City;
      this.organization.PostalCode = this.unmask(this.organizationAddress.PostalCode, this.postalCodeMask);
      this.organization.ProvinceId = this.organizationAddress.ProvinceId;
      this.organization.StreetName = this.organizationAddress.StreetName;
      this.organization.StreetNumber = this.organizationAddress.StreetNumber;
      this.organization.SuiteNumber = this.organizationAddress.SuiteNumber;
      console.log(this.isActive);
      this.organization.IsActive = this.isActive;
      try {
        await this.addOrganization({ payload: this.organization });
        this.close();
        this.$nextTick(()=>{
          this.$refs.table.getDataAsync();
        })
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
      
    },
  },
};
</script>
